<template>
  <div class="dept_detail">
    <!-- 
    <div class="detail">
      <div></div>
      <a-button
        type="primary"
        @back="handleBack"
      >
        返回
      </a-button>
    </div>
    <div>
      <a-descriptions title="基本信息">
        <a-descriptions-item label="部门名称">
          {{ info.deptName ? info.deptName : '--' }}
        </a-descriptions-item>
        <a-descriptions-item label="部门名称">
          {{ info.deptName ? info.deptName : '--' }}
        </a-descriptions-item>
        <a-descriptions-item label="负责人">
          {{ info.leader ? info.leader : '--' }}
        </a-descriptions-item>
        <a-descriptions-item label="负责人名称">
          {{ info.leaderName ? info.leaderName : '--' }}
        </a-descriptions-item>
        <a-descriptions-item label="联系电话">
          {{ info.leaderPhone ? info.leaderPhone : '--' }}
        </a-descriptions-item>
        <a-descriptions-item label="联系电话2">
          {{ info.phone ? info.phone : '--' }}
        </a-descriptions-item>

        <a-descriptions-item label="部门状态">
          {{ info.status ? '正常' : '停用' }}
        </a-descriptions-item>
        <a-descriptions-item label="类型">
          {{ info.type ? '公司' : '部门' }}
        </a-descriptions-item>
        <a-descriptions-item label="邮箱">
          {{ info.email ? info.email : '--' }}
        </a-descriptions-item>
        <a-descriptions-item
          label="公司名称	"
          v-if="info.type == 0"
        >
          {{ info.companyName ? info.companyName : '--' }}
        </a-descriptions-item>
        <a-descriptions-item
          label="公司类型	"
          v-if="info.type == 0"
        >
          {{ info.companyTypeStr ? info.companyTypeStr : '--' }}
        </a-descriptions-item>
        <a-descriptions-item
          label="公司联系方式"
          v-if="info.type == 0"
        >
          {{ info.phone ? info.phone : '--' }}
        </a-descriptions-item>
        <a-descriptions-item
          label="商户号账号"
          v-if="info.type == 0"
        >
          {{ info.subMchidLoginUserName ? info.subMchidLoginUserName : '--' }}
        </a-descriptions-item>
        <a-descriptions-item
          label="商户号密码"
          v-if="info.type == 0"
        >
          {{ info.subMchidLoginPassword ? info.subMchidLoginPassword : '--' }}
        </a-descriptions-item>
        <a-descriptions-item
          label="商户APPID"
          v-if="info.type == 0"
        >
          {{ info.subAppid ? info.subAppid : '--' }}
        </a-descriptions-item>
        <a-descriptions-item
          label="商户号"
          v-if="info.type == 0"
        >
          {{ info.subMchid ? info.subMchid : '--' }}
        </a-descriptions-item>
        <a-descriptions-item
          label="商户号"
          v-if="info.type == 0"
        >
          {{ info.subMchid ? info.subMchid : '--' }}
        </a-descriptions-item>
      </a-descriptions>
    </div> -->
  </div>
</template>

<script>

import { getDept } from '@/api/system/dept'

export default {
  name: 'CreateForm',
  data () {
    return {
      info: {},
      companyAddParam: {}
    }
  },
  filters: {
  },
  created () {

  },
  computed: {
  },
  watch: {
  },
  methods: {
    onClose () {
      this.open = false
    },
    handleBack () {
      this.$emit('back')
    },
    init (id) {
      console.log(id, 'idid');
      getDept(id).then(res => {
        console.log(res, '大大大大大')
        this.info = res.data
        if (res.companyAddParam) {
          this.companyAddParam = res.companyAddParam
        }
      })
    },

  }
}
</script>
<style lang="less" scoped>
.dept_detail {

  // background: #fff;
  .detail {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
